<div class="nav-content" (click)="onItemSelected(item)" [ngClass]="{ 'active-parent-link': item?.route === activePath }">
  <emt-delta-icon
    [ngClass]="item?.iconName"
    [iconName]="item?.iconName"
    class="route-icon"
    [fill]="item?.route === activePath && 'white'"
  ></emt-delta-icon>
  {{ item?.displayName }}
  @if (item?.children && item?.children.length) {
    <emt-delta-icon
      class="arrow"
      iconName="icon-arrow"
      [ngClass]="expanded ? 'invert-arrow' : 'none'"
    ></emt-delta-icon>
  }
</div>
@if (expanded && item && item.children && item.children.length) {
  <ul>
    @for (child of item?.children; track child) {
      <li (click)="onItemSelected(child)" [ngClass]="{ 'active-child-link': child?.route === activePath }">
        {{ child.displayName }}
      </li>
    }
  </ul>
}
